<template>
  <ModalDialog
    ref="dialog"
    title="Edit Payment Received"
    icon="fa-credit-card"
    :showFooter="true"
    :submitting="submitting"
    closeTitle="Cancel"
    submitTitle="Update"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <FormGroup v-bind:form="form" :labelColumnSize="3" v-if="!loading && !loadingError">
      <FormRow label="Payment Type">
        <FormSelect :options="updatablePaymentTypeLookup" v-model="paymentReceived.paymentType" field="paymentType" />
      </FormRow>
      <FormRow label="Location">
        <AccountLocationSelect v-model="paymentReceived.accountLocationId" field="accountLocationId" />
      </FormRow>
      <FormRow label="Reference" :fieldCount="2">
        <template v-slot:field1>
          <FormInputText v-model="paymentReceived.reference" placeholder="Payment Reference" field="reference" />
        </template>
        <template v-slot:field2>
          <FormInputText v-model="paymentReceived.description" placeholder="Additional description" field="description" />
        </template>
      </FormRow>
      <FormRow label="Payment Date">
        <FormDate v-model="paymentReceived.datePayment" placeholder="Payment Date" field="datePayment" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<style scoped>

</style>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import AccountLocationSelect from '@/modules/admin/components/accountLocationSelect'

import { PaymentTypes, PaymentTypeLookup } from '@/store/types'

export default {
  name: 'PaymentReceivedEditDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    AccountLocationSelect
  },
  props: {
    paymentReceivedId: Number
  },
  data() {
    return {
      form: {},
      submitting: false,
      loading: false,
      loadingError: '',
      paymentReceived: {}
    }
  },
  mounted() {
  },
  computed: {
    updatablePaymentTypeLookup() {
      // Cannot set external type
      return PaymentTypeLookup.filter(lookup => lookup.value != PaymentTypes.external)
    }    
  },
  methods: {
    show() {
      this.form = {}
      this.submitting = false

      this.requestData()

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.form = this.clearFormResponse()
      this.submitting = true

      var updateData = {
        paymentType: this.paymentReceived.paymentType,
        reference: this.paymentReceived.reference,
        description: this.paymentReceived.description,
        datePayment: this.paymentReceived.datePayment,
        accountLocationId: this.paymentReceived.accountLocationId
      }

      this.$apiService.accountsService.updatePaymentReceived(this.paymentReceivedId, updateData)
      .then(response => {
        this.modalClosed(response.data)
        this.hide()
      })
      .catch(err => {
        this.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    },
    requestData() {
      this.loading = false
      this.loadingError = ''

      this.$apiService.accountsService.getPaymentReceived(this.paymentReceivedId)
      .then(response => {
        this.paymentReceived = response.data
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>